import React, { createContext, useContext } from 'react';

interface TranslationsProviderProps {
	translations?: TranslationsContext;
	children: React.ReactNode;
}

const context = createContext<TranslationsContext | undefined>({} as TranslationsContext);

export const TranslationsProvider = ({ translations, children }: TranslationsProviderProps) => {
	return <context.Provider value={translations}>{children}</context.Provider>;
};

export const useTranslationsContext = () => useContext(context);

export interface TranslationsContext {
	description: string;
	descriptionPlaceholder: string;
	sendAFile: string;
	validReceipt: string;
	nextStep: string;
	prevStep: string;
	prevStepMobile: string;
	submit: string;
	confirm: string;
	close: string;
	contentDescription: string;
	trackingNumbers: {
		info: string;
		seeCalculator: string;
		seeCalculatorLink: string;
		info2: string;
		enter: string;
		addButton: string;
		errors: {
			'trackingnumber-min': string;
			validation: string;
		};
	};
	recipient: {
		noIcelandicSocialId: string;
		name: string;
		namePlaceholder: string;
		socialId: string;
		socialIdPlaceholder: string;
		email: string;
		emailPlaceholder: string;
		phone: string;
		phonePlaceholder: string;
		errors: {
			required: string;
			'name-invalid': string;
			'phone-invalid': string;
			'phone-max': string;
			'phone-min': string;
			'email-invalid': string;
			'ssn-min': string;
			'ssn-valid': string;
		};
	};
	shipment: {
		hasInvoice: string;
		openUp: string;
		alreadyCleared: string;
		gift: string;
		other: string;
		errors: {
			required: string;
			'file-min': string;
		};
	};
	openUp: {
		option1: string;
		option2: string;
		termsLink: string;
		terms: string;
	};
	alreadyCleared: {
		shipmentClearedText: string;
		shipmentClearedTrackingNumber: string;
		shipmentClearedTrackingNumberPlaceholder: string;
		errors: {
			required: string;
			'invalid-cleared-tracking-number': string;
			'file-min': string;
		};
	};
	gift: {
		explanation: string;
		selectText: string;
		selectPlaceholder: string;
		furtherInfo: string;
		furtherInfoLinkText: string;
		furtherInfoUrl: string;
		giftType: {
			birthday: string;
			graduation: string;
			confirmationOrBaptise: string;
			wedding: string;
			christmas: string;
			other: string;
		};
	};
	delivery: {
		explanation: string;
	};
	terms: {
		explanation: string;
		agreeText: string;
		termsLinkText: string;
		termsLinkUrl: string;
	};
	received: {
		success: string;
		successText: string;
	};
	formStepTitles?: {
		trackingNumbers: string;
		recipient: string;
		shipment: string;
		type: {
			hasInvoice: string;
			openUp: string;
			alreadyCleared: string;
			gift: string;
			other: string;
		};
		delivery: string;
		terms: string;
	};
	inactiveTitles: {
		trackingNumbers: string;
		recipient: string;
		shipment: string;
		type: {
			hasInvoice: string;
			openUp: string;
			alreadyCleared: string;
			gift: string;
			other: string;
		};
		delivery: string;
		terms: string;
	};
}
